import PropTypes from 'prop-types';
import { Component } from 'react';
import Raven from 'raven-js';
/**
 * Pass-through error boundary
 *
 * It rethrows an error after logging it instead of rendering an error state
 * Filters consumers can handle errors as they see fit in their own error boundary
 */
class SegmentationFiltersErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      rethrowError: false
    };
  }
  componentDidMount() {
    Raven.capturePageEvent('cdf-mount');
  }
  componentDidCatch(error, errorInfo) {
    this.reportError(error, errorInfo);
    this.setState({
      rethrowError: true
    });
  }
  reportError(error, errorInfo) {
    Raven.capturePageEvent('cdf-mount-error', {
      extra: {
        errorMessage: error.message,
        errorInfo
      }
    });
  }
  render() {
    if (this.state.error && this.state.rethrowError) {
      throw this.state.error;
    }
    return this.props.children;
  }
}
SegmentationFiltersErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default SegmentationFiltersErrorBoundary;